import React from 'react'
import { iconProps } from '../Helper'

const ArrowDown = ({className}:iconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path className={className} d="M17 9L12 14L7 9" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default ArrowDown
